import React, { createContext, useEffect, useState } from 'react';
import { useWallet } from 'use-wallet';
import PldFinance from '../../pld-finance';
import config from '../../config';

export interface PldFinanceContext {
  pldFinance?: PldFinance;
}

export const Context = createContext<PldFinanceContext>({ pldFinance: null });

export const PldFinanceProvider: React.FC = ({ children }) => {
  const { ethereum, account } = useWallet();
  const [pldFinance, setPldFinance] = useState<PldFinance>();

  useEffect(() => {
    if (!pldFinance) {
      const pld = new PldFinance(config);
      if (account) {
        // wallet was unlocked at initialization
        pld.unlockWallet(ethereum, account);
      }
      setPldFinance(pld);
    } else if (account) {
      pldFinance.unlockWallet(ethereum, account);
    }
  }, [account, ethereum, pldFinance]);

  return <Context.Provider value={{ pldFinance }}>{children}</Context.Provider>;
};
